export default function (initialButtonType = null, defaultContext = {}, extraState = {}) {

    const HASH_MODAL = '#modal';
    const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    const normalizeContextValue = (value) => value === null || value === undefined || value === ''
        ? null
        : value;

    const getGaContext = () => {
        const context = window.__vsebankiGaContext;

        if (context && (context.clientId || context.sessionId)) {
            return context;
        }

        return {clientId: null, sessionId: null, observationId: null, source: 'missing'};
    };

    const applyGaContext = (target, detail = {}) => {
        const currentObservationId = normalizeContextValue(target.ga_observation_id);
        const incomingObservationId = hasOwn(detail, 'observationId')
            ? normalizeContextValue(detail.observationId)
            : currentObservationId;
        const hasExistingIdentifiers = Boolean(target.ga_client_id || target.ga_session_id);
        const observationChanged = incomingObservationId !== null
            && incomingObservationId !== currentObservationId
            && (currentObservationId !== null || hasExistingIdentifiers);
        const sameObservation = hasOwn(detail, 'observationId')
            && incomingObservationId !== null
            && incomingObservationId === currentObservationId;
        const incomingClientId = hasOwn(detail, 'clientId')
            ? normalizeContextValue(detail.clientId)
            : null;
        const incomingSessionId = hasOwn(detail, 'sessionId')
            ? normalizeContextValue(detail.sessionId)
            : null;
        const clientChanged = !observationChanged
            && !sameObservation
            && incomingClientId !== null
            && (target.ga_client_id
                ? incomingClientId !== target.ga_client_id
                : Boolean(target.ga_session_id));
        const sessionChanged = !observationChanged
            && !sameObservation
            && incomingSessionId !== null
            && (target.ga_session_id
                ? incomingSessionId !== target.ga_session_id
                : Boolean(target.ga_client_id));

        const before = JSON.stringify([
            target.ga_client_id,
            target.ga_session_id,
            target.ga_observation_id,
            target.ga_context_source,
        ]);

        if (observationChanged) {
            delete target.ga_client_id;
            delete target.ga_session_id;
        } else if (clientChanged) {
            delete target.ga_session_id;
        } else if (sessionChanged) {
            delete target.ga_client_id;
        }

        if ((clientChanged || sessionChanged) && !hasOwn(detail, 'observationId')) {
            delete target.ga_observation_id;
        }

        if (hasOwn(detail, 'clientId')) {
            const clientId = normalizeContextValue(detail.clientId);
            if (clientId === null && !sameObservation) {
                delete target.ga_client_id;
            } else if (clientId !== null) {
                target.ga_client_id = clientId;
            }
        }

        if (hasOwn(detail, 'sessionId')) {
            const sessionId = normalizeContextValue(detail.sessionId);
            if (sessionId === null && !sameObservation) {
                delete target.ga_session_id;
            } else if (sessionId !== null) {
                target.ga_session_id = sessionId;
            }
        }

        if (hasOwn(detail, 'observationId')) {
            if (incomingObservationId === null) {
                delete target.ga_observation_id;
            } else {
                target.ga_observation_id = incomingObservationId;
            }
        }

        if (hasOwn(detail, 'source')) {
            const source = normalizeContextValue(detail.source);
            if (source === null) {
                delete target.ga_context_source;
            } else {
                target.ga_context_source = source;
            }
        }

        return before !== JSON.stringify([
            target.ga_client_id,
            target.ga_session_id,
            target.ga_observation_id,
            target.ga_context_source,
        ]);
    };

    const requestGaTransport = () => {
        if (typeof window.__vsebankiRequestGaTransport === 'function') {
            window.__vsebankiRequestGaTransport();
            return;
        }

        if (typeof window.CustomEvent === 'function') {
            window.dispatchEvent(new window.CustomEvent('ga-transport-requested'));
        }
    };

    return {
        openLoanOrder: false,
        buttonType: initialButtonType,
        defaultContext,
        leadContext: {},
        ...extraState,

        init() {
            this.setContext();

            window.addEventListener('ga-context-ready', (event) => {
                const context = event?.detail || {};
                if (!context.clientId && !context.sessionId && !context.observationId && !context.source) {
                    return;
                }

                const changed = applyGaContext(this.leadContext, context);

                if (changed && this.openLoanOrder) {
                    this.emitContext();
                }
            });

            window.addEventListener('ga-session-id-ready', (event) => {
                const detail = event?.detail || {};
                if (!detail.sessionId) {
                    return;
                }

                const sessionContext = {sessionId: detail.sessionId};
                if (hasOwn(detail, 'observationId')) {
                    sessionContext.observationId = detail.observationId;
                }
                if (hasOwn(detail, 'source')) {
                    sessionContext.source = detail.source;
                }

                const changed = applyGaContext(this.leadContext, sessionContext);

                if (changed && this.openLoanOrder) {
                    this.emitContext();
                }
            });

            if (window.location.hash === HASH_MODAL) {
                this.openLoanOrder = true;
                requestGaTransport();
                this.emitContext();
            }
            window.addEventListener('hashchange', () => {
                const shouldOpen = window.location.hash === HASH_MODAL;
                this.openLoanOrder = shouldOpen;

                if (shouldOpen) {
                    requestGaTransport();
                    this.setContext();
                    this.emitContext();
                }
            });
        },

        setContext(context = {}) {
            const pageTitle = document.querySelector('h1')?.innerText?.trim() || null;

            const pageUrl = window.location.href;
            const gaContext = getGaContext();

            // @TODO Переделать, решение компромиссное
            //
            // ВАЖНО!!!: порядок spread операторов критичен для корректной работы
            // 1. Сначала defaultContext (базовые значения)
            // 2. Затем специфические поля с fallback логикой
            // 3. В конце context (может динамически перезаписать любые значения)
            this.leadContext = {
                ...this.defaultContext,
                entry_point: this.defaultContext.entry_point ?? this.buttonType ?? 'loan_modal',
                entry_button_type: this.buttonType ?? this.defaultContext.entry_button_type ?? 'loan_modal',
                entry_page_title: this.defaultContext.entry_page_title ?? pageTitle,
                entry_page_url: this.defaultContext.entry_page_url ?? pageUrl,
                ga_client_id: this.defaultContext.ga_client_id ?? gaContext.clientId,
                ga_session_id: this.defaultContext.ga_session_id ?? gaContext.sessionId,
                ga_observation_id: this.defaultContext.ga_observation_id ?? gaContext.observationId,
                ga_context_source: this.defaultContext.ga_context_source ?? gaContext.source,
                ...context,
            };
        },

        emitContext() {
            if (window.Livewire && typeof window.Livewire.emit === 'function') {
                window.Livewire.emit('loan-order-context', this.leadContext);
            }
        },

        pushAnalytics() {
            const pageName = this.leadContext.entry_page_title
                ?? document.querySelector('h1')?.innerText
                ?? 'H1 не найден';

            if (window.GTM && typeof window.GTM.send === 'function') {
                window.GTM.send('broker_start', this.buttonType, pageName);
            }
        },

        handleClick(context = {}) {
            requestGaTransport();
            this.setContext(context);
            this.emitContext();
            this.openLoanOrder = true;
            this.pushAnalytics();
        },
    };
}
